/**
 * shogun-tagging.js — SHOGUN 計測タグ層（DEV-B / PA-26・V8 + PA-33・V2）
 *
 * 目的:
 *   1. 無反応クリック（dead click）と怒りクリック（rage click）の発生要素を特定する。
 *      Clarity の Data Export API は要素セレクタを返さないため、ここで自前に取る。
 *   2. チェックアウト入口（/cart のレジへ進む・PDP/TOP の Buy Now）のクリックを記録し、
 *      checkout_started との断絶を測れるようにする。
 *
 * 設計の制約:
 *   - テーマのマークアップに属性を足さない。9月は DEV-D/F/G/H が同じ画面を触るため、
 *     属性追加は衝突と回帰の原因になる。委譲リスナー1本で完結させる。
 *   - 送るのは要素のCSSパスと tag だけ。テキスト・入力値・data-* の中身は送らない。
 *   - 送信先は Shopify のカスタムイベント。GA4 への変換はカスタムピクセルが行う
 *     （テーマから gtag は呼べない。公式連携のGA4はピクセルのサンドボックス内にある）。
 *
 * 読み込み: theme/layout/theme.liquid の <head> 内・defer
 */
(function () {
  'use strict';

  var MAX_EVENTS = 30;          // 1ページあたりの送信上限
  var RAGE_WINDOW_MS = 800;
  var RAGE_MIN_CLICKS = 3;
  var RAGE_MAX_MOVE_PX = 30;
  var INERT_CHECK_MS = 300;

  var sent = 0;

  function canPublish() {
    return (
      typeof window.Shopify === 'object' &&
      window.Shopify !== null &&
      typeof window.Shopify.analytics === 'object' &&
      window.Shopify.analytics !== null &&
      typeof window.Shopify.analytics.publish === 'function'
    );
  }

  function publish(name, data) {
    if (!canPublish()) return;
    try { window.Shopify.analytics.publish(name, data); } catch (e) { /* 計測で落とさない */ }
  }

  /** ページ種別。GA4側の内訳を粗く割るためだけに使う。 */
  function pageKind() {
    var p = window.location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/cart') === 0) return 'cart';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/pages/') === 0) return 'page';
    if (p.indexOf('/policies/') === 0) return 'policy';
    if (p.indexOf('/blogs/') === 0) return 'blog';
    return 'other';
  }

  /**
   * 短いCSSパスを作る。
   * - 祖先は3階層まで。クラスは各要素2つまで。
   * - id とクラスの中の2桁以上の数字列は # に潰す（section id などが毎回変わるため）。
   * - テキストは一切含めない。
   */
  function cssPath(el) {
    var parts = [];
    var node = el;
    var depth = 0;
    while (node && node.nodeType === 1 && depth < 4) {
      var seg = node.tagName ? node.tagName.toLowerCase() : 'node';
      if (node.id) {
        seg += '#' + String(node.id).replace(/\d{2,}/g, '#');
        parts.unshift(seg);
        break;
      }
      var cls = (node.getAttribute && node.getAttribute('class')) || '';
      var list = cls.split(/\s+/).filter(Boolean).slice(0, 2);
      for (var i = 0; i < list.length; i++) {
        seg += '.' + list[i].replace(/\d{2,}/g, '#');
      }
      parts.unshift(seg);
      node = node.parentElement;
      depth += 1;
    }
    return parts.join('>').slice(0, 90);
  }

  var INTERACTIVE = 'a[href],button,input,select,textarea,label,summary,' +
    '[role="button"],[onclick],[data-shogun-buy-now]';

  function interactiveAncestor(el) {
    if (!el || !el.closest) return null;
    try { return el.closest(INTERACTIVE); } catch (e) { return null; }
  }

  /** チェックアウト入口の種別。該当しなければ null。 */
  function entryPointOf(el) {
    if (!el || !el.closest) return null;
    try {
      // cart-notification の判定を先に行う。/cart 上でポップが開くと
      // #checkout と入れ子にならないが、順序を固定しておくと将来の DOM 変更に強い。
      if (el.closest('#cart-notification-form')) return 'notification_checkout';
      if (el.closest('#checkout')) return 'cart_button';
      if (el.closest('[data-shogun-buy-now]')) return 'buy_now';
    } catch (e) { /* closest 不可のブラウザは諦める */ }
    return null;
  }

  // ---- 怒りクリックの検出 ----
  var recent = [];

  function isRage(x, y, now) {
    recent.push({ x: x, y: y, t: now });
    while (recent.length && now - recent[0].t > RAGE_WINDOW_MS) recent.shift();
    if (recent.length < RAGE_MIN_CLICKS) return false;
    var first = recent[0];
    for (var i = 1; i < recent.length; i++) {
      if (Math.abs(recent[i].x - first.x) > RAGE_MAX_MOVE_PX) return false;
      if (Math.abs(recent[i].y - first.y) > RAGE_MAX_MOVE_PX) return false;
    }
    return true;
  }

  // ---- inert 判定の予約管理 ----
  // 同一箇所への「連続デッドタップ」（rage 候補）では、先行クリックが予約した
  // inert 判定を破棄する。破棄しないと 3連打の1・2打目の300msタイマーが
  // rage 検出後にも発火し、同じ摩擦が inert と rage の両方で二重計上される（AC-M4）。
  // ただし現在のクリックがインタラクティブ要素に着地した場合は破棄しない —
  // 「ミスタップ→すぐ隣のボタンを正しくタップ」のニアミス inert は
  // PA-26/V8 の本来の獲物であり、消してはいけない（PR#159 レビュー指摘）。
  var pendingInert = [];

  function cancelPendingInertNear(x, y, now) {
    var kept = [];
    for (var i = 0; i < pendingInert.length; i++) {
      var p = pendingInert[i];
      if (
        now - p.t <= RAGE_WINDOW_MS &&
        Math.abs(p.x - x) <= RAGE_MAX_MOVE_PX &&
        Math.abs(p.y - y) <= RAGE_MAX_MOVE_PX
      ) {
        window.clearTimeout(p.id);
      } else {
        kept.push(p);
      }
    }
    pendingInert = kept;
  }

  function cancelAllPendingInert() {
    for (var i = 0; i < pendingInert.length; i++) {
      window.clearTimeout(pendingInert[i].id);
    }
    pendingInert = [];
  }

  function report(kind, el) {
    if (sent >= MAX_EVENTS) return;
    sent += 1;
    publish('shogun:ui_click', {
      kind: kind,
      el_id: el && el.id ? String(el.id).replace(/\d{2,}/g, '#').slice(0, 90) : '',
      el_path: cssPath(el),
      el_tag: el && el.tagName ? el.tagName.toLowerCase() : '',
      page_kind: pageKind(),
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target;
      if (!el || el.nodeType !== 1) return;

      var x = event.clientX || 0;
      var y = event.clientY || 0;
      var now = Date.now();
      var actionable = interactiveAncestor(el);
      if (!actionable) {
        cancelPendingInertNear(x, y, now);
      }

      var entry = entryPointOf(el);
      if (entry) {
        publish('shogun:checkout_entry', { entry_point: entry, page_kind: pageKind() });
      }

      if (isRage(x, y, now)) {
        cancelAllPendingInert();
        report('rage', el);
        return;
      }

      if (actionable) {
        report('click', actionable);
        return;
      }

      // 反応しないクリックの候補。300ms 後に画面がまだ同じなら inert として送る。
      var beforeUrl = window.location.href;
      var timer = { x: x, y: y, t: now, id: 0 };
      timer.id = window.setTimeout(function () {
        var idx = pendingInert.indexOf(timer);
        if (idx !== -1) pendingInert.splice(idx, 1);
        if (window.location.href !== beforeUrl) return;
        if (document.querySelector('dialog[open],details[open] > summary:focus')) return;
        report('inert', el);
      }, INERT_CHECK_MS);
      pendingInert.push(timer);
    },
    true
  );

  // ---- スクリプトエラー（PA-12 の js/app.js 404 の実発生率を測る。掃除は DEV-HERO）----
  window.addEventListener(
    'error',
    function (event) {
      if (!event) return;
      var src = event.filename || (event.target && event.target.src) || '';
      if (!src) return;
      publish('shogun:script_error', { src: String(src).slice(0, 120), page_kind: pageKind() });
    },
    true
  );
})();
